var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-all",class:[{ on: _vm.all }],on:{"click":_vm.onShowAll}},[_c('span',[_vm._v(_vm._s(!_vm.all ? _vm.text : '收起'))]),_c('fc-icon',{staticClass:"i",attrs:{"type":"32_down"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }